import { AuthSubscriptions } from '@hefe/auth';
import { t } from '@hefe/i18n';
import {
  ProspectsApi,
  currentUserIsAdminSelector,
  currentUserSelector,
} from '@hefe/store';
import { clubHasSubscription } from '@hefe/utils';
import { Badge, Tabs, TabsProps, Tooltip, Typography } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ProspectsComponent from '../../components/prospects/prospects.component';
import UsersComponent from '../../components/users/users.component';

export default function UsersPage() {
  const user = useSelector(currentUserSelector);
  const userIsAdmin = useSelector(currentUserIsAdminSelector);

  const prospectsAllowed = clubHasSubscription(AuthSubscriptions.third, user);

  const { data, isFetching } = ProspectsApi.useFetchProspectsQuery('', {
    skip: !prospectsAllowed,
  });

  const pendingProspectsCount = useMemo(() => {
    return (
      data?.filter((prospect) => prospect.status === 'pending').length ?? 0
    );
  }, [data]);

  const items = useMemo(() => {
    const returnValue: TabsProps['items'] = [];

    returnValue.push({
      key: 'users',
      label: t('users.users'),
      children: <UsersComponent />,
    });

    if (prospectsAllowed || userIsAdmin) {
      returnValue.push({
        key: 'prospects',
        disabled: !prospectsAllowed,
        label: prospectsAllowed ? (
          <Badge count={pendingProspectsCount} offset={[10, 0]}>
            <Typography.Text>{t('prospects.plural')}</Typography.Text>
          </Badge>
        ) : (
          <Tooltip title={t('errors.permissions.second')}>
            {t('prospects.plural')}
          </Tooltip>
        ),
        children: (
          <ProspectsComponent prospects={data ?? []} isFetching={isFetching} />
        ),
      });
    }

    return returnValue;
  }, [prospectsAllowed, userIsAdmin, pendingProspectsCount, data, isFetching]);

  return <Tabs defaultActiveKey="users" items={items} />;
}
